module.exports = __webpack_public_path__ + "static/img/download.bbab627.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/download.png
// module id = WfQO
// module chunks = 0